import React from 'react';

// Make group for face '.fill--face'
// Make glasses target 'ref="glassesTarget"'
// Make groups for each eye group
// - '.fill-eyes eyes'
// - '.fill-face eyes--blink'
// - '.fill-face eyes--is-being-pet--likes'
// - '.fill-eyes eyes--is-being-pet--hates'

export default class Eyes extends React.Component {
	componentDidMount() {
		this.props.getGlassesTargetCoords(this.refs.glassesTarget);
	}
	render() {
		return (
			<g className="fill--face">
				<circle ref="glassesTarget" cx="212.211853" cy="213.2509918" r="0" />
				<g className="fill--eyes eyes">
					<path d="M192.6565552,213.1061401c0,5.1973877-3.4291687,8.3049011-7.659256,8.3049011
						c-4.2301025,0-7.6592712-3.1075134-7.6592712-8.3049011c0-5.1973724,3.4291687-8.3048859,7.6592712-8.3048859
						C189.2273865,204.8012543,192.6565552,207.9087677,192.6565552,213.1061401z" />
					<path d="M246.3686981,213.1061401c0,5.1973877-3.4291687,8.3049011-7.6592712,8.3049011
						c-4.2300873,0-7.659256-3.1075134-7.659256-8.3049011c0-5.1973724,3.4291687-8.3048859,7.659256-8.3048859
						C242.9395294,204.8012543,246.3686981,207.9087677,246.3686981,213.1061401z" />
				</g>
				<g className="fill--face eyes--blink">
					<path d="M192.3922729,219.0513916c-0.1542969,0-0.3105469-0.0141602-0.4677734-0.0439453l-15.265625-2.8896484
						c-1.3564453-0.2568359-2.2480469-1.5649414-1.9912109-2.9213867c0.2568359-1.3569336,1.5634766-2.2470703,2.9208984-1.9916992
						l15.265625,2.8896484c1.3564453,0.2568359,2.2480469,1.5649414,1.9912109,2.9213867
						C194.6188354,218.2154541,193.5700073,219.0513916,192.3922729,219.0513916z" />
					<path d="M231.3144531,219.0513916c-1.1777344,0-2.2265625-0.8359375-2.453125-2.0356445
						c-0.2568359-1.3564453,0.6347656-2.6645508,1.9912109-2.9213867l15.265625-2.8896484
						c1.3564453-0.2558594,2.6650391,0.6347656,2.9208984,1.9916992c0.2568359,1.3564453-0.6347656,2.6645508-1.9912109,2.9213867
						l-15.265625,2.8896484C231.625,219.0372314,231.46875,219.0513916,231.3144531,219.0513916z" />
				</g>
				<g className="fill--face eyes--is-being-pet--likes">
					<path d="M192.3907623,218.9184875c-0.6044922,0-1.2099609-0.2177734-1.6904297-0.6591797
						c-0.9189453-0.84375-2.9033203-1.7983398-5.7177734-1.9462891c-2.8125-0.1425781-4.8876953,0.5942383-5.8896484,1.3378906
						c-1.1103516,0.8237305-2.6748047,0.5908203-3.4970703-0.5170898c-0.8232422-1.1083984-0.5917969-2.6743164,0.5166016-3.4975586
						c2.234375-1.6591797,5.5507812-2.5053711,9.1318359-2.3164062c3.5683594,0.1875,6.7900391,1.375,8.8388672,3.2578125
						c1.0166016,0.934082,1.0839844,2.515625,0.1494141,3.5322266
						C193.7393951,218.6465149,193.0665436,218.9184875,192.3907623,218.9184875z" />
					<path d="M231.3159637,218.9185333c-0.6757812,0-1.3486328-0.2719727-1.8417969-0.8085938
						c-0.9345703-1.0166016-0.8671875-2.5981445,0.1494141-3.5322266c2.0488281-1.8828125,5.2705078-3.0703125,8.8388672-3.2578125
						c3.5712891-0.1894531,6.8974609,0.6572266,9.1318359,2.3164062c1.1083984,0.8232422,1.3398438,2.3891602,0.5166016,3.4975586
						c-0.8242188,1.1088867-2.3896484,1.3383789-3.4970703,0.5170898c-1.0009766-0.7436523-3.0634766-1.480957-5.8896484-1.3378906
						c-2.8144531,0.1479492-4.7988281,1.1025391-5.7177734,1.9462891
						C232.5259247,218.7007599,231.9204559,218.9185333,231.3159637,218.9185333z" />
				</g>
				<g className="fill--eyes eyes--is-being-pet--hates">
					<path d="M192.6565552,213.1061401c0,5.1973877-3.4291687,8.3049011-7.659256,8.3049011
						c-4.2301025,0-7.6592712-3.1075134-7.6592712-8.3049011c0-4.3017273,3.4291687-4.3016815,7.6592712-4.3016815
						C189.2273865,208.8044586,192.6565552,208.8044128,192.6565552,213.1061401z" />
					<path d="M246.3686981,213.1061401c0,5.1973877-3.4291687,8.3049011-7.6592712,8.3049011
						c-4.2300873,0-7.659256-3.1075134-7.659256-8.3049011c0-4.3605347,3.4291687-4.3016815,7.659256-4.3016815
						C242.9395294,208.8044586,246.3686981,208.7456055,246.3686981,213.1061401z" />
				</g>
			</g>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Global/Pet/LilDoggo/Eyes.js